var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTikTok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0006 3.33203H5.00065C4.07982 3.33203 3.33398 4.07786 3.33398 4.9987V19.9987C3.33398 20.9195 4.07982 21.6654 5.00065 21.6654H20.0006C20.9215 21.6654 21.6673 20.9195 21.6673 19.9987V4.9987C21.6673 4.07786 20.9206 3.33203 20.0006 3.33203ZM18.9081 11.227C18.7998 11.237 18.6906 11.2437 18.5806 11.2437C17.3348 11.2437 16.2398 10.6037 15.6023 9.63453C15.6023 12.1754 15.6023 15.067 15.6023 15.1154C15.6023 17.3529 13.7882 19.1662 11.5515 19.1662C9.31482 19.1654 7.50065 17.3512 7.50065 15.1145C7.50065 12.877 9.31482 11.0637 11.5515 11.0637C11.6365 11.0637 11.719 11.0712 11.8015 11.0762V13.0729C11.7182 13.0629 11.6373 13.0479 11.5515 13.0479C10.4098 13.0479 9.48398 13.9737 9.48398 15.1154C9.48398 16.257 10.409 17.1829 11.5515 17.1829C12.694 17.1829 13.7023 16.2829 13.7023 15.1412C13.7023 15.0954 13.7223 5.83286 13.7223 5.83286H15.6298C15.809 7.5387 17.1865 8.88536 18.9081 9.0087V11.227Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTok);
export default __webpack_public_path__ + "static/media/TikTok.bc98e8a08d7d55ffa637ed51feb1d535.svg";
export { ForwardRef as ReactComponent };